export default __webpack_public_path__ + "static/media/sushi.34e36036.svg";